import { Redirect } from 'expo-router';

import { Payment } from 'experiments/checkout-v2/control/pages/cart/payment/order-payment/payment';
import { useEnableCheckoutV2Experiment } from 'experiments/checkout-v2/use-enable-checkout-v2-experiment';
import { useOrderIsValidCheck } from 'pages/cart/hooks/use-order-is-valid-check';
import { routes } from 'utils/routing';

export default function CartPaymentPage() {
  const isRbiOrderIdValid = useOrderIsValidCheck();
  const isCheckoutV2 = useEnableCheckoutV2Experiment();

  if (!isRbiOrderIdValid) {
    return <Redirect href={routes.cart} />;
  }

  if (isCheckoutV2) {
    return <Redirect href={routes.cartCheckout} />;
  }

  return <Payment />;
}
